import { useState } from "react";
import "@/App.css";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Cursor from "@/components/Cursor";
import Nav from "@/components/Nav";
import TopBanner from "@/components/TopBanner";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/Marquee";
import Portfolio from "@/components/Portfolio";
import Services from "@/components/Services";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Loader from "@/components/Loader";
import CookieBanner from "@/components/CookieBanner";
import PrivacyModal from "@/components/PrivacyModal";
import WhatsAppButton from "@/components/WhatsAppButton";

function App() {
    const [ready, setReady] = useState(false);
    const [privacyOpen, setPrivacyOpen] = useState(false);

    return (
        <div className="App bg-ink-950 text-bone-50 min-h-screen">
            <Loader onDone={() => setReady(true)} />
            <Cursor />
            <TopBanner />
            <SmoothScroll>
                <Nav />
                <main className="pt-[32px] sm:pt-[36px] md:pt-[40px]">
                    {ready && (
                        <>
                            <Hero />
                            <EditorialMarquee />
                            <Portfolio />
                            <Services />
                            <About />
                            <EditorialMarquee />
                            <Contact onOpenPrivacy={() => setPrivacyOpen(true)} />
                        </>
                    )}
                </main>
            </SmoothScroll>
            <CookieBanner onOpenPrivacy={() => setPrivacyOpen(true)} />
            <PrivacyModal open={privacyOpen} onClose={() => setPrivacyOpen(false)} />
            {ready && <WhatsAppButton />}
            <Toaster
                theme="dark"
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#0A0A0A",
                        color: "#FAFAFA",
                        border: "1px solid rgba(255,255,255,0.1)",
                        fontFamily: "JetBrains Mono, monospace",
                        fontSize: "12px",
                        letterSpacing: "0.05em",
                    },
                }}
            />
        </div>
    );
}

export default App;
